// extracted by mini-css-extract-plugin
export default {"radiorer":"SQUxHj","size-20":"x0Hueb","size-22":"G1Bzz4","label":"xrVH4V"};